import { apiRequest } from "../../Timetable/utils/http.js";

// Booking groups Gantt. Reading is open to office users (head counts and
// status labels, no money); saving capacity and the guarantee is admin-only.

/** The Gantt for the given campus-season ids (all active ones in the year when empty). */
export async function getBookingGantt({ year, campusIds = [] }) {
  const params = new URLSearchParams({ year: String(year) });
  if (campusIds.length) params.set("campusIds", campusIds.join(","));
  return apiRequest(`api/booking-gantt?${params.toString()}`);
}

/** { minGuaranteeStudentWeeks, capacity: [{ startDate, endDate, beds, notes }] } */
export async function getGanttSettings(campusId) {
  return apiRequest(`api/booking-gantt/settings/${campusId}`);
}

/** Replaces the season's capacity ranges and guarantee. */
export async function saveGanttSettings(campusId, settings) {
  return apiRequest(`api/booking-gantt/settings/${campusId}`, { method: "PUT", body: settings });
}

/** Every campus-season (one row per centre per season). */
export async function listCampusSeasons() {
  const rows = await apiRequest("api/campuses");
  return Array.isArray(rows) ? rows : [];
}

/** Booking groups as the Groups page lists them, for opening one in the edit dialog. */
export async function listBookingGroups() {
  const rows = await apiRequest("api/campgroups/type/BOOKING");
  return Array.isArray(rows) ? rows : [];
}
